import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ActivityInterceptor } from '@shared/classes/interceptors/activity.interceptor';
import { AuthInterceptor } from '@shared/classes/interceptors/auth-interceptor';
import { BusyInterceptor } from '@shared/classes/interceptors/busy.interceptor';

export const httpInterceptorProviders = [
  addInterceptor(AuthInterceptor),
  addInterceptor(BusyInterceptor),
  addInterceptor(ActivityInterceptor)
];

function addInterceptor<T>(interceptor: T) {
  return {
    provide: HTTP_INTERCEPTORS,
    useClass: interceptor,
    multi: true,
  };
}
